module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-2.9e58c641.webp";